import React, { Component } from 'react'
import { CKEditor } from "ckeditor4-react";

export class HeadingPattern2Component extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHeadingPattern0Edit: false,
      isSubHeadingPattern0Edit: false,
      isHeadingPattern1Edit: false,
      isSubHeadingPattern1Edit: false,
      isHeadingPattern2Edit: false,
      isSubHeadingPattern2Edit: false,
      isHeadingPattern3Edit: false,
      isSubHeadingPattern3Edit: false,
      isHeadingPattern4Edit: false,
      isSubHeadingPattern4Edit: false
    }
  }

  renderCKEditor(content, sort, field) {
    return (
      <CKEditor
        initData={content}
        type="inline"
        className="content-editable"
        onChange={(event) => this.props.handleChangeAlignText(sort, event, field)}
        config={{
          width: '100%',
          height: '300',
          language: 'ja',
          allowedContent: true,
          autoParagraph: false,
          extraPlugins: "justify,font,colorbutton,colordialog",
          font_names: '游ゴシック/Yu Gothic Medium;游明朝/Yu Mincho;ヒラギノ角ゴ Pro W3;メイリオ/メイリオ, Microsoft Sans Serif, Osaka, Arial, sans-serif;ＭＳ ゴシック/ＭＳ ゴシック;ＭＳ 明朝/ＭＳ 明朝;ＭＳ Ｐゴシック/ＭＳ Ｐゴシック;ＭＳ Ｐ明朝/ＭＳ Ｐ明朝;Verdana/Verdana;Arial/Arial;Courier New/Courier New;Times New Roman/Times New Roman',
          toolbar: [
            { name: 'paragraph', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight'] },
            { name: 'styles', items: ['Font'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'styles', items: ['FontSize'] }
          ],
          fontSize_sizes: '10px(PC) ~ 8.8px(SP)/1rem;12px(PC) ~ 10.56px(SP)/1.2rem;14px(PC) ~ 12.32px(SP)/1.4rem;16px(PC) ~ 14.08px(SP)/1.6rem;18px(PC) ~ 15.84px(SP)/1.8rem;20px(PC) ~ 17.6px(SP)/2rem;22px(PC) ~ 19.36px(SP)/2.2rem;24px(PC) ~ 21.12px(SP)/2.4rem;26px(PC) ~ 22.88px(SP)/2.6rem;28px(PC) ~ 24.64px(SP)/2.8rem;36px(PC) ~ 31.68px(SP)/3.6rem;48px(PC) ~ 42.24px(SP)/4.8rem;72px(PC) ~ 63.36px(SP)/7.2rem',
          title: false,
          versionCheck: false
        }}
      />
    );
  }

  renderHeadlinePattern(isEdit, content, sort) {
    let editable = isEdit ? "h contenteditable" : "h";
    editable += this.state[`isHeadingPattern${this.props.positionChild}Edit`] ? " active" : ""
    if (isEdit) {
      return (
        <React.Fragment>
          <h3 className={`${editable}`}>
            {this.renderCKEditor(content[`headline_pattern${this.props.positionChild}`], sort, `headline_pattern${this.props.positionChild}`)}
          </h3>
        </React.Fragment>
      )
    }

    return (<h3 className={`h ${editable}`} dangerouslySetInnerHTML={{__html: content[`headline_pattern${this.props.positionChild}`]}}></h3>)
  }

  renderSubHeadlinePattern(isEdit, content, sort) {
    let editable = this.props.kindOfDesign === 12 ? "h" : ""
    editable += isEdit ? " contenteditable" : "";
    editable += this.state[`isSubHeadingPattern${this.props.positionChild}Edit`] ? " active" : ""
    if (isEdit) {
      return (
        <React.Fragment>
          <p className={`${editable}`}>
            {this.renderCKEditor(content[`subheadline_pattern${this.props.positionChild}`], sort, `subheadline_pattern${this.props.positionChild}`)}
          </p>
        </React.Fragment>
      )
    }

    return (<p className={editable} dangerouslySetInnerHTML={{__html: content[`subheadline_pattern${this.props.positionChild}`]}}></p>)
  }

  render() {
    const { content, isEdit, sort } = this.props;

    return (
      <React.Fragment>
        {this.renderHeadlinePattern(isEdit, content, sort)}
        {(this.props.kindOfDesign != 12) && this.renderSubHeadlinePattern(isEdit, content, sort)}
      </React.Fragment>
    )
  }
}

export default HeadingPattern2Component
